import { render } from "./RightCards.vue?vue&type=template&id=2b524938"
import script from "./RightCards.vue?vue&type=script&lang=js"
export * from "./RightCards.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__